<template>
    <div class="tabs">
        <ul class="nav nav-tabs tabSelector">
            <li class="nav-item"
             @click="() => {selected = 'description'}"
            >
                <div class="nav-link"
                :class="{active:selected == 'description'}">
                Product Description
                </div>
            </li>
            <li class="nav-item"
            v-if="$store.state.auth.loggedIn"
             @click="() => {selected = 'shipping'}"
            >
                <div class="nav-link"
                :class="{active:selected == 'shipping'}">
                Shipping & Freight
                </div>
            </li>
            <li class="nav-item"
             @click="() => {selected = 'discount'}"
            >
                <div class="nav-link"
                :class="{active:selected == 'discount'}">
                Discount Information*
                </div>
            </li>
        </ul>
        <div class="tabContent">
            <div v-if="selected == 'description'" class="" v-html="product.description"></div>
            <div v-if="selected == 'shipping' && $store.state.auth.loggedIn" >
                <div v-if="$store.state.auth.memberLevel == 'silver'">
                    <p>Delivery and handling included for orders over $100.</p>
                    <p>For orders under $100, freight handling fee of $7.50 including GST applies.</p>
                </div>
                <div v-else>
                    <p>
                        <!-- CMS wording -->
                        Freight will be calculated in your shopping cart, which will allow you to choose the most cost effective option.
                    </p>
                    <p>
                        If you require your purchase urgently, please uncheck 'Optimise Freight'.
                    </p>
                    <div class="displayNotes" v-if="product.freight_information && product.freight_information.display_notes" v-html="product.freight_information.display_notes"></div>
                </div>
            </div>

            <div v-if="selected == 'discount'" class="" >
                <!-- CMS wording -->
                <p>Cherrytree relies on the accuracy of information provided by its suppliers. As New Zealand law permits, Cherrytree makes no warranties, expressed or implied, as to any of the goods or services available via Cherrytree.</p>
                <p>*Savings against supplier Recommended Retail Price (RRP) or known average retail pricing where an RRP is not provided. Supplier prices, and therefore savings, may change daily.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "Tabs",
  components:{

  },
  props: ["product"],
  data(){
      return{
          selected: "description",
      }
  },
  computed:{
  }
};
</script>

<style lang="scss" scoped>
.tabs{
    min-height:200px;
}

.nav-tabs{
    font-weight:bold;
}

.tabContent{
    border: 1px solid transparent;
    border-color: transparent #dee2e6 #dee2e6 #dee2e6;
    padding:20px;
	img {
		max-width: 100%;
	}
}

ul li{
    &:before{
        display:none;
    }
}

@include media-breakpoint-down(sm){
	.nav-tabs .nav-item{
		width: 100%;
	}
}

// .tabSelector{
//     .tabTitle{
//         margin:2px;
//         padding:5px;
//         background:grey;
//         display:inline-block;
//         &.selected{
//             background:lightgrey;
//         }
//     }
// }


</style>
